import { motion } from "framer-motion";
import { Unlock, Clock, GraduationCap } from "lucide-react";

const benefits = [
  {
    icon: Unlock,
    title: "Ekscytacja uczniów",
    desc: "Grywalizacja i escape roomy zamieniają naukę w przygodę. Uczniowie sami chcą rozwiązać kolejny szyfr.",
  },
  {
    icon: Clock,
    title: "Oszczędność czasu",
    desc: "AI przejmuje żmudne przygotowania. Gotowe prompty i scenariusze skracają planowanie z godzin do minut.",
  },
  {
    icon: GraduationCap,
    title: "Nowoczesne kompetencje",
    desc: "Rozwijasz u uczniów myślenie krytyczne i cyfrową biegłość — kompetencje przyszłości, już dziś.",
  },
];

export default function Benefits() {
  return (
    <section id="dlaczego" className="py-20 md:py-32 bg-surface border-y border-line">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-sm font-outfit uppercase tracking-[0.2em] text-gold">Korzyści</span>
          <h2 className="mt-4 font-outfit font-medium text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ink leading-tight" data-testid="benefits-title">
            Dlaczego warto złamać kod lekcji?
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-10 md:gap-8">
          {benefits.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="text-center md:text-left"
              data-testid={`benefit-${i}`}
            >
              <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-forest text-gold shadow-clay mb-6">
                <b.icon className="h-7 w-7" strokeWidth={1.5} />
              </span>
              <h3 className="font-outfit font-medium text-xl text-ink">{b.title}</h3>
              <p className="mt-3 font-manrope text-base text-ink-soft leading-relaxed">{b.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
